import arrayMoveImmutable from "../../../../util/arrayMoveImmutable";

export const sortSurveyContentsList = ({ contents, data }) => {
  const { from, to } = data;

  return arrayMoveImmutable(contents, from, to);
};

export default sortSurveyContentsList;
